export enum TaxLabelStatus {
  Exempt = "Exempt",
  Exclusive = "Exclusive",
  Inclusive = "Inclusive",
}

export interface LibraryDisbursement {
  id: number;
  name: string;
  vatStatus: TaxLabelStatus;
  amount: number;
  updatedAt: Date;
  createdBy?: {
    id: number;
    userName: string;
    displayName: string;
  } | null;
}

export interface Disbursement extends LibraryDisbursement {
  order: number;
  autoFocus: boolean | null;
}
